import produce from 'immer';
import create from 'zustand';

const useSeriesConfigurationStore = create(set => ({
  config: {
    rulesOfInvestingPodcastAppleRating: null,
  },
  errors: {},
  set: fn => set(produce(fn)),
}));

export default useSeriesConfigurationStore;
